import { Emitter } from 'zeed'

export const messages = new Emitter()
